<template>
  <section class="footer" role="complementary">
    <div class="container">
      <div class="columns is-centered is-vcentered is-multiline">
        <div class="column is-one-third">
          <a href="https://oi2.edb.utexas.edu/cirtc" aria-label="View the website for the Center for Innovation in Race, Teaching, and Curriculum">
            <figure>
              <img src="logos/cirtc.svg" class="image logo" alt="Logo of the Center for Innovation in Race, Teaching, and Curriculum" />
            </figure>
          </a>
        </div>

        <div class="column is-one-third">
          <a href="https://education.utexas.edu" aria-label="View the website for The University of Texas at Austin College of Education">
            <figure>
              <img src="logos/education.svg" class="image logo" alt="Logo of the The University of Texas at Austin College of Education"/>
            </figure>
          </a>
        </div>

        <div class="column is-one-third">
          <a href="https://liberalarts.utexas.edu/history" aria-label="View the website for The University of Texas at Austin Department of History">
            <figure>
              <img src="logos/history.svg" class="image logo"  alt="Logo of the The University of Texas at Austin Department of History"/>
            </figure>
          </a>
        </div>

        <div class="column is-one-third">
          <a href="https://www.humanitiestexas.org/" aria-label="View the website for Humanities Texas">
            <figure>
              <img src="logos/humanitiestexas.png" class="image logo" alt="Logo of Humanities Texas"/>
            </figure>
          </a>
        </div>

        <div class="column is-one-third">
          <a href="https://txdst.la.utexas.edu/" aria-label="View the website for the Texas Domestic Slave Trade Project">
            <figure>
              <img src="logos/txdst.png" class="image logo" alt="Logo of the Texas Domestic Slave Trade Project" />
            </figure>
          </a>
        </div>

        <div class="column is-one-third">
          <a href="https://www.cah.utexas.edu" aria-label="View the website for the Briscoe Center for American History">
            <figure>
              <img src="logos/briscoecenter.png" class="image logo" alt="Logo of the Briscoe Center for American History" />
            </figure>
          </a>
        </div>

        <div class="column is-one-third">
          <a href="http://www.glo.texas.gov/save-texas-history" aria-label="View the website for the Save Texas History Program of the Texas General Land Office">
            <figure>
              <img src="logos/savetexashistory.png" class="image logo" alt="Logo of the Save Texas History Program of the Texas General Land Office" />
            </figure>
          </a>
        </div>

        <div class="column is-one-third">
          <a href="https://www.tsl.texas.gov" aria-label="View the website for the Texas State Library and Archives Commission">
            <figure>
              <img src="logos/txlibraryarchives.png" class="image logo" alt="Logo of the Texas State Library and Archives Commission" />
            </figure>
          </a>
        </div>
      </div>
    </div>
    <hr />
    <div class="columns is-centered">
      <div class="column">
        <p>&copy;The University of Texas at Austin 2019</p>
        <p>
          <a href="https://www.utexas.edu/site-policies" aria-label="View Site Policies of The University of Texas at Austin">Site Policies</a> |
          <a href="https://cio.utexas.edu/policies/web-privacy" aria-label="View the Web Privacy Policy of The University of Texas at Austin">Web Privacy Policy</a> |
          <a href="https://cio.utexas.edu/policies/web-accessibility" aria-label="View the Web Accessibility Policy of The University of Texas at Austin">Web Accessibility Policy</a>
        </p>
        <p class="built-by">Built by the <a href="https://education.utexas.edu/about/college-offices/office-instructional-innovation" aria-label="View the website for the Office of Instructional Innovation">Office of Instructional Innovation</a>,<br>part of the <a href="https://education.utexas.edu" aria-label="View the website for the UT-Austin College of Education">College of Education</a> at <a href="https://utexas.edu" aria-label="View the website for The University of Texas at Austin">The University of Texas at Austin</a></p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Footer",
  props: {
    msg: String
  }
};
</script>

<style scoped>
.footer {
  background: #fff;
  color: #222;
  padding: 2rem;
}

.footer a {
  color: #fff;
}
.logo {
  max-height: 150px;
  max-width: 100%;
  padding: 10px;
  margin: 0 auto;
}

.column {
  text-align: center;
}

hr {
  background-color: #ccc;
}

.built-by{
  margin-top:1em;
}
</style>
